export { default } from "bullitttime-embermodelsevent/adapters/finish-timing-record";
